module.exports = __webpack_public_path__ + "img/Jacobs.1747e1ab.jpeg";